module.exports = __webpack_public_path__ + "static/media/fullScreenIcon.00b89e23.svg";